<template>
  <div class="more-from-the-author__wrapper">
    <h2 class="more-from-the-author__title">
      {{ title }}
    </h2>

    <ul class="more-from-the-author__articles">
      <li
        v-for="article in articles"
        :key="article.id"
        class="article-most-viewed__list-item"
      >
        <article-slot :article="article" />
      </li>
    </ul>
  </div>
</template>

<script>
import { PROP_TYPES, propValidator } from '@/utils/validators'
import ArticleSlot from 'shared/ArticleSlots/Fm/ArticlePage/AArticleSlotMoreFromTheAuthor'

export default {
  name: 'MoreFromTheAuthor',
  components: { ArticleSlot },
  props: {
    articles: propValidator([PROP_TYPES.ARRAY]),
    isMoreThanOneAuthor: propValidator([PROP_TYPES.BOOLEAN], false, false)
  },
  computed: {
    title() {
      return `More from the Author${this.isMoreThanOneAuthor ? 's' : ''}`
    }
  },
  mounted() {
    this.$emit('mounted')
  }
}
</script>

<style scoped lang="scss">
@import '~assets/scss/local/mixins/grid';
@import '~assets/scss/local/styles/article';

.more-from-the-author__wrapper {
  .more-from-the-author__title {
    @extend .section-title;
  }

  .more-from-the-author__articles {
    margin-top: 15px;
    border-radius: 5px;

    $border: (
      $above-desktop-xl: 1px solid $c--gray-dark-1,
      $mobile: none
    );
    $padding: (
      $above-desktop-xl: 20px,
      $mobile: 0
    );

    $grid-setup: (
      $columnSetup: (
        $above-desktop-xl: repeat(3, minmax(0, 100%)),
        $desktop-lg: repeat(2, minmax(0, 100%)),
        $mobile: minmax(0, 100%)
      ),
      $columnGapSetup: (
        $above-desktop-xl: 25px
      ),
      $rowGapSetup: (
        $above-desktop-xl: 20px
      )
    );

    @include gridBuilder($grid-setup);
    @include setStyleByBreakpoint('border', $border);
    @include setStyleByBreakpoint('padding', $padding);
  }
}
</style>
